import React from 'react';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import AccessControl, {SUPER_ADMIN_ROLE} from 'pwm-shared/dist/AccessControl';
import {paths} from 'src/PWM/paths';
import {useAuth} from 'src/PWM/hooks/use-auth';
import {useRouter} from 'src/PWM/hooks/use-router';
import {useToast} from 'src/PWM/hooks/use-toast';
import {PWMLoadingIndicator} from '../PWMLoadingIndicator';
import {useSettings} from 'src/hooks/use-settings';
import {PwmSeo} from 'src/PWM/components/page/PwmSeo';
import PWMBreadcrumbs, {BreadcrumbData} from './PWMBreadcrumbs';
// import {useAnalytics} from 'src/PWM/hooks/use-analytics';


const PWMPageContainer: React.FC<IPWMPageContainerProps> = (props) => {
  const {breadcrumbs, children, isLoading, title, message, redirectTo, allowedRoles} = props;

  const settings = useSettings();
  const {account} = useAuth();
  const toast = useToast();
  const router = useRouter();

  // const analytics = useAnalytics();

  if(allowedRoles instanceof Function) {
    if(!account) return null;
    const goForSuperAdmin = account.role === SUPER_ADMIN_ROLE;

    const goForUserPermission = AccessControl.hasRolePermissions(account.userRoles, allowedRoles());

    if ((!goForSuperAdmin || !goForUserPermission) && redirectTo) {
      toast.error(message || 'You are not authorized to access this page!');
      router.replace(redirectTo || paths.authenticated.home);
      return null;
    }
  }

  return (
    <>
      <PwmSeo title={title}/>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          py: 2
        }}
      >
        <Container maxWidth={settings.stretch ? false : 'xl'}>
          {breadcrumbs && (
            <PWMBreadcrumbs data={breadcrumbs}/>
          )}
          {children}
        </Container>
      </Box>
      <PWMLoadingIndicator spin={isLoading || false}/>
    </>
  )
};

export default PWMPageContainer;

interface IPWMPageContainerProps {
  title: string;
  allowedRoles?(): string[];
  redirectTo?: string;
  message?: string;
  breadcrumbs?: BreadcrumbData[];
  isLoading?: boolean;
  children?: React.ReactNode;
}